import {
  AbstractControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import {
  ALPHA_NUMERIC_PATTERN,
  EMAIL_PATTERN,
  NAME_PATTERN,
  PASSWORD_PATTERN,
} from '../constants/reg-exp-patterns';

const CONSECUTIVE_NUMBERS = 3;

export class FormUtils {
  static getTextError(errors: ValidationErrors) {
    for (const key of Object.keys(errors)) {
      switch (key) {
        case 'required':
          return 'Este campo es requerido';

        case 'minlength':
          return `Mínimo de ${errors['minlength'].requiredLength} caracteres`;

        case 'maxlength':
          return `Máximo de ${errors['maxlength'].requiredLength} caracteres`;

        case 'min':
          return `Valor mínimo de ${errors['min'].min}`;

        case 'max':
          return `Valor máximo de ${errors['max'].max}`;

        case 'email':
          return `El valor ingresado no luce como un correo electrónico`;

        case 'pattern':
          const requiredPattern = errors['pattern'].requiredPattern;

          if (requiredPattern === EMAIL_PATTERN) {
            return 'El valor ingresado no luce como un correo electrónico';
          }

          if (requiredPattern === PASSWORD_PATTERN) {
            return 'La contraseña debe tener por lo menos 1 letra minúscula, 1 letra mayúscula y 1 número';
          }

          if (requiredPattern === NAME_PATTERN) {
            return 'Este campo no debe incluir caracteres especiales';
          }

          if (requiredPattern === ALPHA_NUMERIC_PATTERN) {
            return 'Este campo solo acepta letras y números';
          }

          return 'Error de patrón contra expresión regular';

        case 'field2MustBeGreater':
          return 'El valor del campo 2 debe ser mayor al valor del campo 1';

        case 'fieldsNotEqual':
          return 'Los campos deben ser iguales';

        case 'excludedWord':
          return 'El valor no debe contener palabras comunes o relacionadas con la empresa o tu nombre';

        case 'consecutiveNumbers':
          return `El valor no debe contener ${CONSECUTIVE_NUMBERS} o más números consecutivos`;

        default:
          return `Error de validación no controlado ${key}`;
      }
    }

    return null;
  }

  static isValidField(form: FormGroup, fieldName: string): boolean | null {
    return (
      !!form.controls[fieldName].errors && form.controls[fieldName].touched
    );
  }

  static getFieldError(form: FormGroup, fieldName: string): string | null {
    if (!form.controls[fieldName]) return null;

    const errors = form.controls[fieldName].errors ?? {};

    return FormUtils.getTextError(errors);
  }

  static getFormError(form: AbstractControl, errorKey: string): string | null {
    if (!form.errors) return null;

    if (!form.errors[errorKey]) return null;

    return this.getTextError({ [errorKey]: form.errors[errorKey] });
  }

  static isInvalidControl(control: AbstractControl | null): boolean {
    return !!control && control.touched && !!control.errors;
  }

  static getControlError(control: AbstractControl | null): string | null {
    if (!control || !control.errors) return null;

    return FormUtils.getTextError(control.errors);
  }

  static isFieldOneEqualFieldTwo(field1: string, field2: string) {
    return (formGroup: AbstractControl) => {
      const field1Value = formGroup.get(field1)?.value;
      const field2Value = formGroup.get(field2)?.value;

      return field1Value === field2Value ? null : { fieldsNotEqual: true };
    };
  }

  static isFieldTwoGreaterThanFieldOne(field1: string, field2: string) {
    return (formGroup: AbstractControl) => {
      const field1Value = +formGroup.get(field1)?.value;
      const field2Value = +formGroup.get(field2)?.value;

      return field2Value > field1Value ? null : { field2MustBeGreater: true };
    };
  }

  static validateExludedWords(userName: string = ''): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const wordsToExclude = [
        'pepsico',
        'Pepsico',
        'PEPSICO',
        'CAE',
        'cae',
        'Cae',
      ];
      if (userName) {
        const newWordsToExclude = [
          userName.split(' '),
          userName.toLowerCase().split(' '),
          userName.toUpperCase().split(' '),
        ];
        wordsToExclude.push(...newWordsToExclude.flat());
        // console.log(wordsToExclude);
        // console.log(control.value);
      }

      const hasExcludedWord = wordsToExclude.some((word) =>
        control.value.includes(word),
      );
      return hasExcludedWord ? { excludedWord: true } : null;
    };
  }

  static validateConsecutiveNumbers(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const fieldValue = control.value;
      let numbersCount = 0;

      for (let i = 0; i < fieldValue.length; i++) {
        // console.log(fieldValue[i]);

        if (/\d/.test(fieldValue[i])) {
          numbersCount++;
          if (numbersCount >= CONSECUTIVE_NUMBERS) {
            return { consecutiveNumbers: true };
          }
        } else {
          numbersCount = 0;
        }
      }

      return null;
    };
  }
}
